'use client'

import { lazy } from 'react'

// The server footer has its own Suspense boundary. Preserve its SSR content
// without adding its behavior to the header's initial script requests.
const FooterAuthButton = lazy(() =>
  import('./footer-auth-button').then((module) => ({ default: module.FooterAuthButton }))
)

export const FooterAuthButtonLazy = () => <FooterAuthButton />
